import { DateTime } from 'luxon';
import { WEEKDAYS } from '../constants';
import cloneDateTime from './cloneDateTime';

export default function getCalendarMonthWeeks(
    month,
    enableOutsideDays,
    firstDayOfWeek = DateTime.local().firstDayOfWeek || 0 // Default to current locale's first day of the week
) {
    if (!(month instanceof DateTime) || !month.isValid) {
        throw new TypeError('`month` must be a valid Luxon DateTime object');
    }
    if (WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
        throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
    }

    // set utc offset to get correct dates in future (when timezone changes)
    const firstOfMonth = cloneDateTime(month).startOf('month').set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
    });

    const lastOfMonth = cloneDateTime(month).endOf('month').set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 9999,
    });
    // calculate the exact first and last days to fill the entire matrix
    // (considering days outside month)
    const prevDays = (firstOfMonth.weekday + 7 - firstDayOfWeek) % 7;
    const nextDays = (firstDayOfWeek + 6 - lastOfMonth.weekday) % 7;
    const firstDay = cloneDateTime(firstOfMonth).minus({ days: prevDays });
    const lastDay = cloneDateTime(lastOfMonth).plus({ days: nextDays });

    const totalDays = lastDay.diff(firstDay, 'days').days + 1;

    const weeksInMonth = [];
    let currentDay = firstDay;

    while (currentDay <= lastDay) {
        const week = [];

        // Fill the week with days
        for (let i = 0; i < 7; i++) {
            let day = null;

            if (currentDay.month === month.month || enableOutsideDays) {
                day = cloneDateTime(currentDay);
            }

            week.push(day);
            currentDay = currentDay.plus({ days: 1 });
        }

        weeksInMonth.push(week);
    }

    return weeksInMonth;
}
